// ==============================|| DEFAULT THEME - TYPOGRAPHY  ||============================== //

const Typography = (fontFamily = 'Roboto, Arial, sans-serif', fontFamilySpecial = 'Roboto, Arial, sans-serif') => ({
	htmlFontSize: 16,
	fontFamily,

	fontWeightLight: 300,
	fontWeightRegular: 400,
	fontWeightMedium: 500,
	fontWeightBold: 700,


	h1: { fontFamily: fontFamilySpecial, fontWeight: 700, fontSize: '4rem',   lineHeight: 1.1 },
	h2: { fontFamily: fontFamilySpecial, fontWeight: 700, fontSize: '3rem',   lineHeight: 1.15 },
	h3: { fontFamily: fontFamilySpecial, fontWeight: 600, fontSize: '2.25rem',lineHeight: 1.2 },
	h4: { fontFamily: fontFamilySpecial, fontWeight: 600, fontSize: '1.5rem', lineHeight: 1.25 },
	h5: { fontFamily: fontFamilySpecial, fontWeight: 600, fontSize: '1.25rem',lineHeight: 1.3 },
	h6: { fontFamily: fontFamilySpecial, fontWeight: 600, fontSize: '1.125rem',lineHeight: 1.35 },


	body1: { fontFamily, fontSize: '1rem',    lineHeight: 1.57 },  // 16px
	body2: { fontFamily, fontSize: '0.875rem',lineHeight: 1.66 },  // 14px
	caption:  { fontFamily, fontSize: '0.75rem',  lineHeight: 1.66 }, // 12px
	subtitle1:{ fontFamily, fontSize: '1rem',     fontWeight: 600, lineHeight: 1.57 },
	subtitle2:{ fontFamily, fontSize: '0.875rem', fontWeight: 600, lineHeight: 1.66 },

	overline: { fontFamily, fontSize: '0.75rem', letterSpacing: '0.08em', textTransform: 'uppercase', lineHeight: 1.66 },

	button: { fontFamily, fontSize: '0.875rem', fontWeight: 600, textTransform: 'none', lineHeight: 1.2 }
});

export default Typography;
